import { FC, ReactNode } from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { As, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { getDataTracking } from '../../../utils';

export interface HeaderMenuItemProps {
  children: ReactNode;
  isLast?: boolean;
  to?: string;
  href?: string;
  icon?: As;
}

export const HeaderMenuItem: FC<HeaderMenuItemProps> = ({
  children,
  to,
  href,
  icon,
  ...rest
}) => (
  <Link
    href={href}
    to={`${to}`}
    as={href ? undefined : RouteLink}
    color="brand.primary.darkGrey"
    fontWeight="normal"
    textDecoration="none"
    _visited={{ color: 'brand.primary.darkGrey' }}
    {...getDataTracking(`header${children}Link`)}
  >
    <Flex>
      {icon && <Icon as={icon} boxSize="24px" />}
      <Text fontSize="md" display="block" ml={2.5} {...rest}>
        {children}
      </Text>
    </Flex>
  </Link>
);
